import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-acknowledge-overlay',
  templateUrl: './acknowledge-overlay.component.html',
  styleUrls: ['./acknowledge-overlay.component.scss']
})
export class AcknowledgeOverlayComponent implements OnInit {
  @Input() text!: string;

  @Output() closed = new EventEmitter<boolean>();

  showOverlay = false;

  constructor() {
  }

  ngOnInit(): void {
    this.showOverlay = this.text != null && this.text.trim() !== '';
  }

  agree(): void {
    this.showOverlay = false;
    this.closed.emit(true);
  }
}
